import { render, staticRenderFns } from "./ordersFilters.vue?vue&type=template&id=63ca9321&scoped=true&"
import script from "./ordersFilters.vue?vue&type=script&lang=js&"
export * from "./ordersFilters.vue?vue&type=script&lang=js&"
import style0 from "./ordersFilters.vue?vue&type=style&index=0&id=63ca9321&prod&lang=scss&scoped=true&"
import style1 from "./ordersFilters.vue?vue&type=style&index=1&id=63ca9321&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ca9321",
  null
  
)

export default component.exports